import { format, isValid, parseISO } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../constants/date'
import { getQaSelector } from '../../../../utils/common'
import { DRAFT_CREATE_ACTION } from '../../../Draft'
import { TableCellText } from '../../../Table'
import { APPLICANT_FORM_FIELD_NAME_LISTING } from '../RentalPortalApplicantForm'
import {
  getApplicantDraftFormValues,
  getApplicantDraftSavedAt,
} from '../RentalPortalApplicants.hooks'

import {
  QA_NAME_APPLICANT_DRAFT_LISTING,
  QA_NAME_APPLICANT_DRAFT_SAVED_AT,
} from './RentalPortalApplicantDraftCreateActionSelectModal.constants'

export function getApplicantDraftListingLabel(draft) {
  return getApplicantDraftFormValues(draft)?.[APPLICANT_FORM_FIELD_NAME_LISTING]
    ?.label
}

export function getApplicantDraftSavedAtLabel(draft) {
  const savedAt = getApplicantDraftSavedAt(draft)

  const savedAtDate = savedAt ? parseISO(savedAt) : null

  return savedAtDate && isValid(savedAtDate)
    ? format(savedAtDate, DATE_FULL_FORMAT_FROM_TIME)
    : null
}

export function getApplicantDraftCreateActionOptions({
  listingLabel,
  listingLabelClassName,
  savedAtClassName,
  savedAtLabel,
  t,
}) {
  return [
    {
      id: DRAFT_CREATE_ACTION.createNew,
      label: t('RentalPortal.ListingDraftCreateNewActionKey'),
    },
    {
      id: DRAFT_CREATE_ACTION.openDraft,
      label: (
        <>
          {t('RentalPortal.ListingDraftOpenActionKey')}
          {listingLabel ? (
            <span
              {...getQaSelector({ value: QA_NAME_APPLICANT_DRAFT_LISTING })}
              className={listingLabelClassName}
            >
              <TableCellText showTooltip={false} value={listingLabel} />
            </span>
          ) : null}
          {savedAtLabel ? (
            <span
              {...getQaSelector({ value: QA_NAME_APPLICANT_DRAFT_SAVED_AT })}
              className={savedAtClassName}
            >
              {savedAtLabel}
            </span>
          ) : null}
        </>
      ),
    },
  ]
}
